import { useEffect, useState, HTMLAttributes } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { intervalId } from '../../common/support-util'
import './survey.css'

import axios from "axios";

interface AppContactsFrom {
    frequency?: string;
    satisfaction?: string;
    reasons?: string[];
    comment?: string;
}

export const Survey = (props: HTMLAttributes<any>) => {
    const [btnClz, setBtnClz] = useState(["btnSubmit"])
    const history = useHistory();
    const {
        register,
        handleSubmit,
        setValue
    } = useForm<AppContactsFrom>();

    // 送信処理(web側バリデーション通過後)
    const onSubmit: SubmitHandler<AppContactsFrom> = async (
        data: AppContactsFrom
    ) => {
        setBtnClz([...btnClz, "sending"])// くるくるアイコン
        if (!data.reasons) {
            data.reasons = undefined
        }
        await axios.post("/api/v1/sp/app/survey", data)
            .then(() => {
                clearInterval(intervalId)
                window.location.href = "fns://account-delete/survey/submit"
            })
            .catch(() => window.location.href = "fns://account-delete/survey/submit");
    };

    useEffect(() => {
        const searched = /token=([^&]+)/.exec(window.location.search)
        let token = searched ? searched[1] : null
        if (!token) {
            history.push("/errors/400");
        }
    }, [history, setValue]);

    return (
        <div className='contact'>
            <main className="wrapper">
                <>
                    <p className="contactExplain">
                        <b>退会前に下記のアンケートのご協力お願いいたします。</b>
                    </p>
                    <section className="secContact">
                    <form id="frmSurvey" name="frm-survey" onSubmit={handleSubmit(onSubmit)}>
                            <ul className="formlist">
                                <li>
                                    <dl>
                                        <dt><b>■本アプリを利用していた頻度を教えて下さい。</b></dt>
                                        <dd>
                                            <ul className="formlist__radio">
                                                <div>
                                                <li>
                                                    <label><input {...register("frequency")} type="radio" id="frmFrequency1" value="ほとんど毎日" name="frequency"/>ほとんど毎日</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("frequency")} type="radio" id="frmFrequency2" value="2〜3日に1度" name="frequency"/>2〜3日に1度</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("frequency")} type="radio" id="frmFrequency3" value="1週間に1〜2回程度" name="frequency"/>1週間に1〜2回程度</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("frequency")} type="radio" id="frmFrequency4" value="1ヶ月に1〜2回程度" name="frequency"/>1ヶ月に1〜2回程度</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("frequency")} type="radio" id="frmFrequency5" value="1ヶ月に1度もない" name="frequency"/>1ヶ月に1度もない</label>
                                                </li>
                                                </div>
                                            </ul>
                                        </dd>
                                        <dt><b>■サービスの満足度を教えて下さい。</b></dt>
                                        <dd>
                                            <ul className="formlist__radio2">
                                                <li>
                                                    <label><input {...register("satisfaction")} type="radio" id="frmSatisfaction1" value="非常に良い" name="satisfaction"/>非常に良い</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("satisfaction")} type="radio" id="frmSatisfaction2" value="良い" name="satisfaction"/>良い</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("satisfaction")} type="radio" id="frmSatisfaction3" value="どちらとも言えない" name="satisfaction"/>どちらとも言えない</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("satisfaction")} type="radio" id="frmSatisfaction4" value="悪い" name="satisfaction"/>悪い</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("satisfaction")} type="radio" id="frmSatisfaction5" value="非常に悪い" name="satisfaction"/>非常に悪い</label>
                                                </li>
                                            </ul>
                                        </dd>
                                        <dt><b>■アカウント削除の理由を教えて下さい。</b></dt>
                                        <dd>
                                            <ul className="formlist__radio3">
                                                <li>
                                                    <label><input {...register("reasons")} type="checkbox" id="frmReason1" value="使い方がわからないから"/>使い方がわからないから</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("reasons")} type="checkbox" id="frmReason2" value="使いづらいから"/>使いづらいから</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("reasons")} type="checkbox" id="frmReason3" value="使いたい機能がないから"/>使いたい機能がないから</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("reasons")} type="checkbox" id="frmReason4" value="一緒に使う人がいないから"/>一緒に使う人がいないから</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("reasons")} type="checkbox" id="frmReason5" value="一緒に使ってた人(家族)がやめてしまったから"/>一緒に使ってた人(家族)がやめてしまったから</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("reasons")} type="checkbox" id="frmReason6" value="コミュニケーションが面倒だから"/>コミュニケーションが面倒だから</label>
                                                </li>
                                                <li>
                                                    <label><input {...register("reasons")} type="checkbox" id="frmReason7" value="その他"/>その他</label>
                                                    <textarea {...register("comment")} id="frmReasonMsg" cols={50} rows={5} placeholder="退会された理由をご入力ください"></textarea>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </li>
                            </ul>
                            <input id="surveySubmit" type="submit"/> 
                        </form>
                    </section> 
                </>
            </main>
        </div>
    );
};
